/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/ui/text';

import ActiveTool from '../ActiveTool';
import ToolList from '../ToolList';
import { Container, Subtitle } from './styledComponents';

function Home({
  isActiveToolExist,
  activeToolData,
  toolList,
  contactUsDocUrl,
  ectCredentials,
  navToBM,
  navToSetup,
  navToAthena,
  navToSetupFqdn,
  deactivateConfiguration,
  activateContactSalesTeamDialog,
}) {
  return (
    <Container>
      <Text variant="display-2.semi-bold" color="black.haptik">
        Agent Escalations
      </Text>
      {!isActiveToolExist && (
        <Subtitle variant="body.lg" color="black.haptik">
          Choose a tool from below to get started with setting up your choice of
          agent escalation tool.
        </Subtitle>
      )}
      {isActiveToolExist && (
        <ActiveTool
          name={activeToolData?.name}
          iconUrl={activeToolData?.iconUrl}
          lastEdited={activeToolData?.lastEdited}
          toolDocUrl={activeToolData?.toolDocUrl}
          contactUsDocUrl={contactUsDocUrl}
          onEdit={navToSetup}
        />
      )}
      <ToolList
        toolList={toolList}
        isActiveToolExist={isActiveToolExist}
        activeToolName={activeToolData.name}
        deactivateConfiguration={deactivateConfiguration}
        ectCredentials={ectCredentials}
        navToBM={navToBM}
        navToAthena={navToAthena}
        navToSetupFqdn={navToSetupFqdn}
        activateContactSalesTeamDialog={activateContactSalesTeamDialog}
      />
    </Container>
  );
}

Home.propTypes = {
  isActiveToolExist: PropTypes.bool,
  activeToolData: PropTypes.shape({
    name: PropTypes.string,
    iconUrl: PropTypes.string,
    lastEdited: PropTypes.string,
    toolDocUrl: PropTypes.string,
  }),
  toolList: PropTypes.arrayOf(PropTypes.shape({})),
  contactUsDocUrl: PropTypes.string,
  ectCredentials: PropTypes.shape({}).isRequired,
  navToBM: PropTypes.func.isRequired,
  navToSetup: PropTypes.func.isRequired,
  navToAthena: PropTypes.func.isRequired,
  navToSetupFqdn: PropTypes.func.isRequired,
  deactivateConfiguration: PropTypes.func.isRequired,
  activateContactSalesTeamDialog: PropTypes.func.isRequired,
};

Home.defaultProps = {
  isActiveToolExist: false,
  activeToolData: {},
  toolList: [],
  contactUsDocUrl: '',
};

export default React.memo(Home);
